/* eslint-disable */
import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { WithChildrenProps } from '@app/types/generalTypes';

const Require: React.FC<WithChildrenProps> = ({ children }) => {
  const token = sessionStorage.getItem('token');
  return token ? <>{children}</> : <Navigate to="/" replace />;
};
export default Require;
